import { useState } from 'react';
import { cn } from '../../lib/cn';
import { GeographieTab } from './GeographieTab';
import { TypesUnitesTab } from './TypesUnitesTab';
import { CataloguesTab } from './CataloguesTab';
import { CoefficientsTab } from './CoefficientsTab';
import { ImportTab } from './ImportTab';
import { TemplatesTab } from '../documents/TemplatesTab';

type RefTab = 'geo' | 'types' | 'catalogues' | 'coefficients' | 'import' | 'templates';

const TABS: { key: RefTab; label: string }[] = [
  { key: 'geo', label: 'Géographie' },
  { key: 'types', label: 'Types & unités' },
  { key: 'catalogues', label: 'Catalogues' },
  { key: 'coefficients', label: 'Coefficients' },
  { key: 'import', label: 'Import' },
  { key: 'templates', label: 'Modèles de documents' },
];

/**
 * « Référentiels » (DEC-005) : conteneur à onglets pour la gestion géographique, les types tarifables,
 * les catalogues de coûts versionnés, les coefficients et l'import XLSX/CSV. La sécurité et toutes les
 * règles métier restent côté serveur — cette page ne fait que router vers les sous-écrans.
 */
export function ReferentielsPage(): JSX.Element {
  const [tab, setTab] = useState<RefTab>('geo');
  return (
    <div className="max-w-6xl space-y-4">
      <h1 className="text-xl font-semibold text-slate-800">Référentiels</h1>
      <div
        role="tablist"
        aria-label="Référentiels"
        className="flex flex-wrap border-b border-slate-200"
      >
        {TABS.map((t) => (
          <button
            key={t.key}
            type="button"
            role="tab"
            aria-selected={tab === t.key}
            onClick={() => setTab(t.key)}
            className={cn(
              '-mb-px border-b-2 px-3 py-2 text-sm font-medium transition-colors',
              tab === t.key
                ? 'border-brand-600 text-brand-700'
                : 'border-transparent text-slate-500 hover:text-slate-700',
            )}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'geo' ? <GeographieTab /> : null}
      {tab === 'types' ? <TypesUnitesTab /> : null}
      {tab === 'catalogues' ? <CataloguesTab /> : null}
      {tab === 'coefficients' ? <CoefficientsTab /> : null}
      {tab === 'import' ? <ImportTab /> : null}
      {tab === 'templates' ? <TemplatesTab /> : null}
    </div>
  );
}
